import React from 'react';
import PropTypes from 'prop-types';

import { Menu, MenuList, MenuButton, MenuItem } from '@reach/menu-button';

import { BodyText } from '../../StyledComponents';
import ArrowIcon from '../../../../icons/arrow-down-24.svg';

import StyledButton from './StyledButton';
import { languageOptions, languageEnum } from './languages';

import './LanguageSelector.module.scss';

const StyledMenuButton = StyledButton.withComponent(MenuButton);
StyledMenuButton.displayName = 'StyledMenuButton';

function LanguageSelector(props) {
  const { language, onChange = () => {}, designSettings } = props;

  const {
    languageSelectorTextColor,
    languageSelectorTextHoverColor,
    languageSelectorMenuTextColor,
    languageSelectorMenuBackgroundColor,
    languageSelectorMenuTextHoverColor,
    languageSelectorMenuBackgroundHoverColor,
    languageSelectorMenuTextActiveColor,
    languageSelectorMenuBackgroundActiveColor,
  } = designSettings || {};

  const onSelect = (selectedLanguage) => {
    onChange(selectedLanguage);
  };

  return (
    <Menu>
      {({ isOpen }) => (
        <div>
          <StyledMenuButton
            color={languageSelectorTextColor}
            hoverColor={languageSelectorTextHoverColor}
            data-active={isOpen ? 1 : null}
          >
            <BodyText styleName="label" data-label type="bodySecondary">
              {language}
            </BodyText>
            <ArrowIcon styleName="icon" data-icon aria-hidden="true" />
          </StyledMenuButton>
          <MenuList
            as="ul"
            styleName="list"
            style={{
              color: languageSelectorMenuTextColor,
              backgroundColor: languageSelectorMenuBackgroundColor,
            }}
          >
            {languageOptions.map((lang) => (
              <MenuItem
                as="li"
                key={lang.value}
                styleName="item"
                data-active={lang.value === language ? 1 : null}
                style={{
                  '--hover-color': languageSelectorMenuTextHoverColor,
                  '--background-hover-color': languageSelectorMenuBackgroundHoverColor,
                  '--active-color': languageSelectorMenuTextActiveColor,
                  '--background-active-color': languageSelectorMenuBackgroundActiveColor,
                }}
                onSelect={() => onSelect(lang.value)}
              >
                <BodyText type="bodySecondary">{lang.label}</BodyText>
              </MenuItem>
            ))}
          </MenuList>
        </div>
      )}
    </Menu>
  );
}

LanguageSelector.propTypes = {
  language: PropTypes.oneOf(languageEnum),
  onChange: PropTypes.func,
  designSettings: PropTypes.object,
};

export default React.memo(LanguageSelector);
